module.exports = __webpack_public_path__ + "static/img/gaoxinjisu.5af3ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/gaoxinjisu.jpg
// module id = D9Mq
// module chunks = 7